import React from "react";
import ReduxContainerHOC from "../../hoc/ReduxContainerHOC";
import {validateField} from "../../utils/validation";
import * as actions from "./actions";
import PropTypes from "prop-types";
import {setSEODataOnClient} from "../../utils/utils";
import {ReviewContentLoader} from "../../components/ShikshaApply/Review/widgets/ContentLoaderPage";
import ESTracking from "../../utils/esTracking";
import config from "../../config/config";
// import {GlobalFontStyles} from "../../components/CommonStyled/widgets/Styled";
import CounselingReview from "../../components/ShikshaApply/Review";
import {ErrorBoundary} from "../../hoc/ErrorBoundary";

class CounselingReviewPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            sort: "recency",
            pageNumber: 1,
            reviews: [],
            showContentLoader: false,
            showCardContentLoader: false,
        };
        this.fetchingReview = false;
    }

    componentDidMount() {
        this.trackPageData();
        const {counselingRatingData, counselingReviewData} = this.props;
        let promise = null;
        if (
            typeof counselingRatingData === "undefined" &&
            typeof counselingReviewData === "undefined"
        ) {
            this.setState({showContentLoader: true});
            promise = this.props.fetchCounselingRatingReviewData().promiseObj;
            promise.then(() => {
                setSEODataOnClient(this.props.counselingRatingData.data);
                this.setState({
                    reviews: this.props.counselingReviewData.data.userReviewData,
                    showContentLoader: false,
                });
            });
        } else {
            this.setState(
                {
                    reviews: counselingReviewData.data.userReviewData,
                    showContentLoader: false,
                },
                this.scrollHandle,
            );
        }
        this.scrollHandle();
    }

    scrollHandle = () => {
        window.scrollTo(0, 0);
    };
    trackPageData = () => {
        const {globalLayoutProps} = this.props;
        // Beacon Tracking
        let beaconTrackData = {};
        beaconTrackData["extraData"] = null;
        beaconTrackData["pageIdentifier"] = globalLayoutProps.pageName;
        ESTracking(beaconTrackData, config.BEACON_TRACK_URL);
    };

    doSort = (sortCat) => {
        if (this.state.sort !== sortCat) {
            this.setState({sort: sortCat, showCardContentLoader: true});
            let param = btoa(JSON.stringify({sortBy: sortCat}));
            let promise = null;
            promise = this.props.fetchCounselingReviewData(param);
            promise.then(() => {
                this.setState({
                    reviews: this.props.counselingReviewData.data.userReviewData,
                    showCardContentLoader: false,
                });
            });
        }
    };

    paginateReviews = () => {
        if (this.fetchingReview === false) {
            this.fetchingReview = true;
            let newPageNumber = this.state.pageNumber + 1;
            let param = btoa(JSON.stringify({sortBy: this.state.sort, pn: newPageNumber}));
            let promise = null;
            promise = this.props.fetchCounselingReviewData(param);
            promise.then(() => {
                let newReviewList = [
                    ...this.state.reviews,
                    ...this.props.counselingReviewData.data.userReviewData,
                ];
                this.setState({
                    reviews: newReviewList,
                    pageNumber: newPageNumber,
                });
                this.fetchingReview = false;
            });
        }
    };

    render() {
        const {counselingRatingData, counselingReviewData} = this.props;
        if (
            this.state.showContentLoader ||
            (typeof counselingRatingData === "undefined" &&
                typeof counselingReviewData === "undefined")
        ) {
            return <ReviewContentLoader />;
        }

        let reviewList = [];
        if (this.state.reviews.length > 0) {
            reviewList = this.state.reviews;
        } else {
            reviewList = this.props.counselingReviewData.data.userReviewData;
        }

        return (
            <ErrorBoundary>
                {/*<GlobalFontStyles/>*/}

                <CounselingReview
                    counselingRatingData={counselingRatingData.data}
                    counselingReviewData={counselingReviewData.data}
                    reviewList={reviewList}
                    doSort={this.doSort}
                    sortType={this.state.sort}
                    loadMore={this.paginateReviews}
                    userLoggedIn={this.props.userLoggedIn}
                    isMobile={this.props.isMobile}
                    showCardContentLoader={this.state.showCardContentLoader}
                />
            </ErrorBoundary>
        );
    }
}
const requestInitialData = (checkReturnData, extraParams) => {
    if (checkReturnData === true) {
        return "yes";
    }

    const {headerConfig} = extraParams;
    return actions.fetchCounselingRatingReviewData(headerConfig, extraParams);
};

const mapStateToProps = (state) => {
    return {
        counselingRatingData: state.CounselingReviewPage.counselingRatingData,
        counselingReviewData: state.CounselingReviewPage.counselingReviewData,
        isMobile: state.layout.isMobile,
        userLoggedIn: validateField(state.layout.userAndShortlistData, "object", "userLoggedIn")
            ? state.layout.userAndShortlistData.userLoggedIn
            : undefined,
    };
};

CounselingReviewPage.propTypes = {
    counselingRatingData: PropTypes.object,
    counselingReviewData: PropTypes.object,
    fetchCounselingRatingReviewData: PropTypes.func,
    fetchCounselingReviewData: PropTypes.func,
    userLoggedIn: PropTypes.bool,
    isMobile: PropTypes.bool,
    globalLayoutProps: PropTypes.object,
};

export default ReduxContainerHOC(CounselingReviewPage, mapStateToProps, actions, {
    requestInitialData,
});
